import { useState } from 'react';

import { CsvExportParams, GridApi } from 'ag-grid-community';
import { getCurrentDate } from 'src/util/dateTimeUtil';

export const useExportCoreRates = () => {
    const [filterText, setFilterText] = useState('');
    const [cppGridApi, setCppGridApi] = useState<GridApi>();
    const [mauGridApi, setMauGridApi] = useState<GridApi>();

    const exportCoreRates = () => {
        const currentDate = getCurrentDate();
        const cppGridExportParams: CsvExportParams = {
            fileName: `cpp_core_rates_export_${currentDate}.csv`
        };
        const mauGridExportParams: CsvExportParams = {
            fileName: `mau_core_rates_export_${currentDate}.csv`
        };
        cppGridApi?.exportDataAsCsv(cppGridExportParams);
        mauGridApi?.exportDataAsCsv(mauGridExportParams);
    };

    return { filterText, setFilterText, setCppGridApi, setMauGridApi, exportCoreRates };
};
